import styled, { css } from 'styled-components/macro'
import Box, { BoxProps } from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'
import { colorNames } from 'styles/theme'

interface ModalHeaderProps extends BoxProps {
    hasDarkMode?: boolean
}

export const ModalHeader = styled(Box)<ModalHeaderProps>`
    padding: 24px 56px 16px 16px;
    background-color: ${({ theme, hasDarkMode }) =>
        hasDarkMode ? theme.colors.grayscale_900 : theme.colors.grayscale_0};
    border-bottom: 1px solid ${({ theme }) => theme.colors.grayscale_300};

    @media ${respondAbove.md} {
        padding: 32px 40px;
        border-radius: 8px 8px 0 0;

        &:has(:not(:first-child)) {
            border-radius: 0;
        }
    }
`

interface ModalCalendarProps extends BoxProps {
    hasDarkMode?: boolean
}

export const ModalCalendar = styled(Box)<ModalCalendarProps>`
    ${({ theme, hasDarkMode }) =>
        hasDarkMode &&
        css`
            background-color: ${colorNames.darkmode_900};
        `};
`

interface ModalFooterProps extends BoxProps {
    hasDarkMode?: boolean
}

export const ModalFooter = styled(Box)<ModalFooterProps>`
    height: 100%;
    flex-grow: 1;
    justify-content: space-between;
    padding: 0 16px 24px;
    background-color: ${({ theme, hasDarkMode }) =>
        hasDarkMode ? colorNames.darkmode_900 : theme.colors.grayscale_0};
    border-radius: ${({ hasDarkMode }) => (hasDarkMode ? '0' : '0 0 8px 8px')};

    @media ${respondAbove.md} {
        padding: 0 40px 40px;
        border-radius: 0 0 8px 8px;

        &:has(:not(:first-child)) {
            border-radius: 0;
        }
    }
`

export const ModalFooterListItemsWrapper = styled(Box)`
    @media ${respondAbove.xl} {
        &:not(:last-child) {
            border-right: ${({ theme }) =>
                `2px solid ${theme.colors.grayscale_300}`};
        }
    }
    img {
        min-width: 12px;
    }
`
